import { SignUp } from "./SignUp";

new SignUp();